import api from './api';

const listSurveys = query => api.get('/api/program-surveys/', { params: query });

export default {
  listSurveys,
};
